
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { singleton as singleton_1, ofArray, isEmpty, map as map_1, choose } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { defaultArg, map } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { ViewHelpers_mkText, ViewHelpers_mkColumn, ViewHelpers_divWith } from "./PortWindCommon.js";
import { Color, theme } from "../../Theme.js";
import { append, singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { FSharpMap__TryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { TileLayer } from "react-leaflet";
import { comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { mapMarker } from "../../images/map-marker.svg.js";
import server from "react-dom/server";
import { DivIcon } from "leaflet";
import { Tooltip_View } from "../../Components/Leaflet/Tooltip.js";
import { Marker_View } from "../../Components/Leaflet/Marker.js";
import { FeatureGroup_View } from "../../Components/Leaflet/FeatureGroup.js";
import { MapContainer_View } from "../../Components/Leaflet/Container.js";

export function AllSensorsMapView($props) {
    const onSensorSelected = $props.onSensorSelected;
    const centerAndZoom = $props.centerAndZoom;
    const state = $props.state;
    const sensorsWithLocation = choose((sensor) => map((location) => [sensor, location], sensor.Location), state.Sensors);
    const locations = map_1((tuple) => tuple[1], sensorsWithLocation);
    return ViewHelpers_divWith([["style", {
        backgroundColor: theme(new Color(1, [])),
        color: theme(new Color(0, [])),
        height: 100 + "%",
        width: 100 + "%",
    }]], singleton_1(ViewHelpers_mkColumn(singleton_1(ViewHelpers_divWith([["style", {
        width: 100 + "%",
        height: 80 + "vh",
        borderRadius: 8 + "px",
        overflow: "hidden",
    }]], toList(delay(() => {
        let p_1_5;
        return isEmpty(locations) ? singleton(ViewHelpers_mkText(theme(new Color(0, [])), 3, [], "No sensors with location data available")) : singleton((p_1_5 = ofList(map_1((value_29) => value_29, toList(delay(() => append(defaultArg(map((_arg) => ofArray([["center", _arg.fields[0]], ["zoom", _arg.fields[1]]]), centerAndZoom), singleton_1(["bounds", locations])), delay(() => singleton(["children", toList(delay(() => {
            let props;
            return append(singleton((props = {
                attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            }, react.createElement(TileLayer, props))), delay(() => map_1((tupledArg) => {
                let p_1_3, props_1, arg, arg_1, arg_2, arg_3, arg_4, p_1_2;
                const sensor_1 = tupledArg[0];
                const isSelected = equals(state.SelectedSensor, sensor_1.SensorId);
                const markerClass = isSelected ? "selected" : "";
                const p_1_4 = ofList(map_1((value_28) => value_28, ofArray([["onClick", (_arg_1) => {
                    onSensorSelected(sensor_1.SensorId);
                }], ["children", singleton_1((p_1_3 = ofList(map_1((value_27) => value_27, ofArray([["position", tupledArg[1]], ["zIndexOffset", isSelected ? 1000 : 0], ["icon", (props_1 = ofArray([["html", mapMarker], ["iconSize", [32, 32]], ["iconAnchor", [16, 16]], ["className", markerClass]]), (arg = defaultArg(map((element) => server.renderToString(element), map((x_1) => x_1, FSharpMap__TryFind(ofList(map_1((value_20) => value_20, props_1), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }), "html"))), ""), (arg_1 = map((x_3) => x_3, FSharpMap__TryFind(ofList(map_1((value_22) => value_22, props_1), {
                    Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
                }), "iconSize")), (arg_2 = map((x_5) => x_5, FSharpMap__TryFind(ofList(map_1((value_23) => value_23, props_1), {
                    Compare: (x_4, y_2) => (comparePrimitives(x_4, y_2) | 0),
                }), "iconAnchor")), (arg_3 = map((x_7) => x_7, FSharpMap__TryFind(ofList(map_1((value_24) => value_24, props_1), {
                    Compare: (x_6, y_3) => (comparePrimitives(x_6, y_3) | 0),
                }), "popupAnchor")), (arg_4 = map((x_9) => x_9, FSharpMap__TryFind(ofList(map_1((value_25) => value_25, props_1), {
                    Compare: (x_8, y_4) => (comparePrimitives(x_8, y_4) | 0),
                }), "className")), new DivIcon({html: arg, iconSize: arg_1, iconAnchor: arg_2, popupAnchor: arg_3, className: arg_4})))))))], ["children", singleton_1((p_1_2 = ofList(map_1((value_26) => value_26, singleton_1(["children", singleton_1(ViewHelpers_mkText(theme(new Color(0, [])), 2, [], sensor_1.Name))])), {
                    Compare: (x_10, y_5) => (comparePrimitives(x_10, y_5) | 0),
                }), createElement(Tooltip_View, {
                    p: p_1_2,
                })))]])), {
                    Compare: (x_11, y_6) => (comparePrimitives(x_11, y_6) | 0),
                }), createElement(Marker_View, {
                    p: p_1_3,
                })))]])), {
                    Compare: (x_12, y_7) => (comparePrimitives(x_12, y_7) | 0),
                });
                return createElement(FeatureGroup_View, {
                    p: p_1_4,
                });
            }, sensorsWithLocation)));
        }))])))))), {
            Compare: (x_13, y_8) => (comparePrimitives(x_13, y_8) | 0),
        }), createElement(MapContainer_View, {
            p: p_1_5,
        })));
    })))))));
}

